<template>
	<el-select v-model="weekVal" v-bind="$attrs" @change="e=>$emit('change',e)">
		<el-option v-for="item in weekList" :key="item.key" :label="item.name" :value="item.key"/>
	</el-select>
</template>

<script>
import { count } from '@/api/server'
	export default {
        props:{
            week:{
                type:Number,
                default:0
            },
            count:{
                type:Number,
                default:24
            }
        },
		
		data() {
            console.log('this.week=',this.week)
			return {
				weekList: [],
                weekVal:this.week
			}
		},
        watch:{
            week(v){
                console.log('=====>',v)
                this.weekVal=v
            }
        },
        model:{
            prop:'week',
            event:'change'
        },
		mounted() {
			this.weekList = Array.from({ length: this.count }, (_, i) => 1 + i * 1).map(v => {
				return {
					key: v,
					name: `第${v}周`
				}
			})
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/select-week.vue